import axios from "axios";
import { createMockAxiosAdapter } from "./mockApi";
import { syncMockModePreference } from "./mockMode";

const registerMockMode = () => {
  if (typeof window === "undefined") return false;

  const enabled = syncMockModePreference(window, process.env);
  if (!enabled) return false;

  if (!window.__SKGATE_AXIOS_MOCK_PATCHED__) {
    axios.defaults.adapter = createMockAxiosAdapter();
    window.__SKGATE_AXIOS_MOCK_PATCHED__ = true;
  }

  return true;
};

registerMockMode();

export default registerMockMode;
